import React from 'react';
import { Flame, Target, Grid3x3, CircleDot, Trophy, Stamp } from 'lucide-react';

const features = [
  {
    icon: Flame,
    title: 'Dnevni Check-In',
    description: 'Prijavi se svaki dan i osvoji bonus bodove. 7-dnevni streak = dupli bodovi!',
    color: 'text-go2-pink',
    bgColor: 'bg-pink-50',
  },
  {
    icon: Target,
    title: 'Izazovi & Misije',
    description: 'Sezonski izazovi sa rokovima i nagradama. Ispuni misiju, osvoji bodove.',
    color: 'text-go2-blue',
    bgColor: 'bg-blue-50',
  },
  {
    icon: Grid3x3,
    title: 'Destinacijski Bingo',
    description: '3x3 bingo tabela destinacija. Poseti red i osvoji mega bonus!',
    color: 'text-yellow-600',
    bgColor: 'bg-yellow-50',
  },
  {
    icon: CircleDot,
    title: 'Točak Sreće',
    description: 'Posle svakog putovanja — besplatno vrtenje za bonus bodove!',
    color: 'text-purple-600',
    bgColor: 'bg-purple-50',
  },
  {
    icon: Trophy,
    title: 'Rang Lista',
    description: 'Mesečna takmičenja. Budi među top 10 putnika i osvoji posebne nagrade.',
    color: 'text-green-600',
    bgColor: 'bg-green-50',
  },
  {
    icon: Stamp,
    title: 'Putni Pasoš',
    description: 'Sakupljaj markice za svaku destinaciju. Kolekcionar putovanja!',
    color: 'text-orange-600',
    bgColor: 'bg-orange-50',
  },
];

export const GamificationShowcase: React.FC = () => {
  return (
    <section className="pt-12 pb-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 uppercase tracking-wide mb-4">
            Više od programa <span className="text-go2-pink">lojalnosti</span>
          </h2>
          <div className="w-24 h-1 bg-go2-yellow mx-auto mb-6"></div>
          <p className="text-xl text-gray-500 max-w-2xl mx-auto">
            Svako putovanje je nova avantura — izazovi, nagrade, takmičenja i ekskluzivna iskustva čekaju.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 text-center hover:shadow-lg hover:scale-105 transition-all duration-200"
              >
                <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center mx-auto mb-6`}>
                  <Icon className={`w-8 h-8 ${feature.color}`} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 uppercase">{feature.title}</h3>
                <p className="text-gray-600 leading-relaxed">{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
